import { Alert } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
  width: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`;
